<template>
    <main>
        <HeaderView></HeaderView>
        <RouterView />
        <footer class="footer mt-auto py-3 bg-light">
            <div class="container">
                <span class="text-muted">© sonnen (vpp preparation) 2022-</span>
            </div>
        </footer>
    </main>
</template>

<script>
import HeaderView from "@/views/HeaderView.vue";

export default {
    components: {
        HeaderView
    }
};
</script>

<style lang="scss">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
